// extracted by mini-css-extract-plugin
export var copyIcon = "_yv-2";
export var discountCard = "_yv-0";
export var discountCode = "_yv-3";
export var discountContent = "_yv-1";
export var loadingCard = "_yv-4";